module.exports = __webpack_public_path__ + "img/othon-moreno.39e46aca.png";